import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

/* Utilities */
import { randomString } from 'util/string'

/* Styles */
import './index.css'

import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
}

/* Single Playlist List Item */
export default class TagInput extends Component {

    constructor(props) {
        super(props)
        this.ref = []
        this.state = { edit: false, value: _.clone(props.value || []), index: -1 }
    }

    equalTags(a, b) {
      return ((!a)?[]:a).join("") === ((!b)?[]:b).join("")
    }

    componentWillReceiveProps(nextProps) {
        if (this.equalTags(this.props.value, nextProps.value)) return
        this.setState({ value: _.clone(nextProps.value) })
    }

    componentDidUpdate() {
      if(this.ref[this.state.index] && this.ref[this.state.index] !== document.activeElement) this.ref[this.state.index].focus()
    }

    onKeyDown(index, e) {
        if(!this.state.edit) return // ignore all events while not in edit mode
        switch (e.keyCode) {
            case 8: // backspace
                if (e.target.value.length == 0) {
                  e.preventDefault()
                  e.stopPropagation()
                  this.decrementIndex()
                }
                break
            case 13: // enter
                e.preventDefault()
                e.stopPropagation()
                this.onSave()
                break
            case 27: // esc
                e.preventDefault()
                e.stopPropagation()
                this.onCancel()
                break
            case 32: // space
                if (e.target.value.length && e.target.selectionStart==e.target.value.length) {
                  this.addNewTag(index)
                }
                e.preventDefault()
                e.stopPropagation()
                break
            case 37: // arrow left
                if(e.target.selectionStart==0){
                  e.preventDefault()
                  e.stopPropagation()
                  this.decrementIndex()
                }
                break
            case 39: // arrow right
                if(e.target.selectionStart==e.target.value.length){
                  e.preventDefault()
                  e.stopPropagation()
                  this.incrementIndex()
                }
                break
        }
    }

    incrementIndex() {
      if (this.state.index >= this.state.value.length-1) return
      this.setState({index: ++this.state.index})
    }

    decrementIndex() {
      if (this.state.index < 1) return
      this.setState({index: --this.state.index})
    }

    addNewTag(index) {
      var tags = this.state.value
      tags.splice(index+1, 0, "")
      this.setState({value:tags, index: ++index})
    }

    onSave() {
        if (!this.isValid()) return
        if (this.props.onSave) this.props.onSave(this.state.value)
        if(this.ref[this.state.index]) this.ref[this.state.index].blur()
    }

    onReset() {
        if (this.props.onReset) this.props.onReset()
        this.setState({ value: this.props.defaultValue || [""] })
        if (this.state.edit) {
          //this.onTagChange(0, this.state.value, true)
        }
    }

    onUndo() {
        if (this.props.onUndo) this.props.onUndo()
        this.setState({ value: this.props.value })
        //if(this.ref[this.state.index]) this.ref[this.state.index].blur()
    }

    onCancel() {
        if (this.props.onCancel) this.props.onCancel()
        if(this.ref[this.state.index]) this.ref[this.state.index].blur()
    }

    onTagFocus(index, e) {
        this.setState({ edit: true, index })
        if (this.props.onEdit) this.props.onEdit()
    }

    onTagBlur(index, e) {
        if (this.state.edit) {
          this.onTagChange(index, e.target.value, true)
        }
        this.setState({ edit: false, index: -1 })
    }

    onTagChange(index, value, force) {
      var tags = this.state.value
      if (value.length == 0 && (tags.length > 1 || force)) {
        tags.splice(index--, 1)
      } else {
        tags[index] = value
      }
      this.setState({value: tags, index})
    }

    onClick(e) {
        if (this.state.edit) e.stopPropagation() // only during edit state
        e.preventDefault()
    }

    onDragStart(e) {
        if (!this.state.edit) return // only during edit state
        e.stopPropagation()
        e.preventDefault()
    }

    onDragOver(e) {
        if (!this.state.edit) return // only during edit state
        //e.stopPropagation()
        e.dataTransfer.dropEffect='none'
        e.preventDefault()
    }

    onDragEnter(e) {
        if (!this.state.edit) return // only during edit state
        //e.stopPropagation()
        e.dataTransfer.dropEffect='none'
        e.preventDefault()
    }

    onDrop(e) {
        e.dataTransfer.dropEffect='none'
        e.preventDefault()
        if (!this.state.edit) return // only during edit state
        //e.stopPropagation()
    }

    onMouseDown(e) {
        e.preventDefault()
    }

    onButtonMouseDown(e) {
        // stop focus loss
        e.stopPropagation()
        e.preventDefault()
    }

    onSaveButtonClick(e) {
        e.stopPropagation()
        e.preventDefault()
        this.onSave()
    }

    onResetButtonClick(e) {
        e.stopPropagation()
        e.preventDefault()
        this.onReset()
    }

    onUndoButtonClick(e) {
        e.stopPropagation()
        e.preventDefault()
        this.onUndo()
    }

    hasChanged() {
      return !this.equalTags(this.props.value, this.state.value)
    }

    isValid() {
        const { validate } = this.props
        const { value } = this.state
        return !validate || validate(value)
    }

    getClassName() {
        const {
            className
        } = this.props
        let classNameArr = (className || "").split(' ')
        classNameArr.push('tag-input', 'widget')
        if (this.hasChanged()) classNameArr.push('changed')
        return  classNameArr.join(' ')
    }


    getInputClassName(idx) {
        const { index } = this.state
        let cls = ["tag-wrapper"]
        if (index === idx) cls.push('focus')
        if (!this.isValid()) cls.push('invalid')
        return cls.join(" ") || null
    }

    getContainerClassName() {
      let cls = ["tag-container"]
      if (this.state.index != -1) cls.push('focus')
      if (!this.isValid()) cls.push('invalid')
      return cls.join(" ") || null
    }

    renderSaveButton() {
        const {
            edit
        } = this.state
        const {
            saveTitle
        } = this.props
        if (edit && this.hasChanged() && this.isValid() &&  !this.props.noSave) {
            return (
                <button
                    tabIndex="-1"
                    onClick={ this.onSaveButtonClick.bind(this) }
                    onMouseDown={ this.onButtonMouseDown.bind(this) }
                    title={ saveTitle }
                >
                    <Icon icon={ ICON.SAVE } size={ 24 }/>
                </button>
            )
        }
    }

    renderUndoButton() {
        const {
            edit
        } = this.state
        const {
            resetTitle
        } = this.props
        if (edit && this.hasChanged() &&  !this.props.noUndo) {
            return (
                <button
                    tabIndex="-1"
                    onClick={ this.onUndoButtonClick.bind(this) }
                    onMouseDown={ this.onButtonMouseDown.bind(this) }
                    title={ resetTitle }
                >
                    <Icon icon={ ICON.UNDO } size={ 24 }/>
                </button>
            )
        }
    }

    renderResetButton() {
        const {
            edit,
        } = this.state
        const {
            clearTitle
        } = this.props
        if (edit && !this.props.noReset) {
            return (
                <button
                    tabIndex="-1"
                    onClick={ this.onResetButtonClick.bind(this) }
                    onMouseDown={ this.onButtonMouseDown.bind(this) }
                    title={ clearTitle }
                >
                    <Icon icon={ ICON.DELETETEXT } size={ 24 }/>
                </button>
            )
        }
    }

    renderLabel() {
        const { label, labelWidth } = this.props
        if (!label) return null
        var style = (!labelWidth)?{}:{width: labelWidth+"px"}
        return (
            <div className="inputLabel" style={ style }>{ label }</div>
        )
    }

    renderInputToolbar() {
        const {
            edit
        } = this.state

        return (
            <div className="toolbar">
                { this.renderSaveButton() }
                { this.renderUndoButton() }
                { this.renderResetButton() }
            </div>
        )
    }

    renderTagsPlaceholder() {
        const {
          edit,
          value,
          t
        } = this.state
        const {
          placeholder
        } = this.props
        if (!edit && !value.length) return <div className="tag-placeholder">{ placeholder }</div>
    }

    renderTags() {
        const {
          value
        } = this.state
        return (
          <div
            className={ this.getContainerClassName() }
            onClick={
              (e) => {
                if(value.length == 0){
                  value.push("")
                }
                this.setState({index: value.length-1})
                if (this.state.edit) e.stopPropagation()
                e.preventDefault()
              }
            }
          >
              {
                _.map(value, (tag, index) => {
                  var w = getTextWidth(tag, "11px OrkneyLight")
                  return <div key={index} className={ this.getInputClassName(index) }><span className="hashtag">#</span><input
                      type="text"
                      value={tag}
                      style={ {width: (Math.ceil(6+w))+"px"} }
                      ref={ (elem)=>{ this.ref[index] = elem }}
                      onClick={ this.onClick.bind(this)}
                      onKeyDown={ (e)=>{ this.onKeyDown(index, e) } }
                      onFocus={ (e)=>{ this.onTagFocus(index, e) } }
                      onBlur={ (e)=>{ this.onTagBlur(index, e) } }
                      onChange={ (e)=>{ this.onTagChange(index, e.target.value)}}
                  /></div>
                })
              }
              { this.renderTagsPlaceholder() }
              <div className="tag-spacer"></div>
          </div>
        )
    }

    getInputType() {
        return this.props.password?"password":"text"
    }

    render() {
        const {
            title,
            placeholder,
            labelWidth,
            disabled
        } = this.props
        const {
            edit,
            value
        } = this.state
        var style = (!labelWidth)?{}:{minWidth: (110+labelWidth).toString() + "px"}
        return (
            <div
                draggable={ !edit }
                className={ this.getClassName() }
                style={ style }
            >
                <div className="toolbar-wrapper">
                    { this.renderLabel() }
                    { this.renderTags() }

                    { this.renderInputToolbar() }
                </div>
            </div>
        )
    }
}

TagInput.propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string,
    labelWidth: PropTypes.number,
    title: PropTypes.string,
    value: PropTypes.array,
    defaultValue: PropTypes.array,
    onChange: PropTypes.func,
    onInput: PropTypes.func,
    onCancel: PropTypes.func,
    onReset: PropTypes.func,
    onUndo: PropTypes.func,
    onSave: PropTypes.func,
    onEdit: PropTypes.func,
    validate: PropTypes.func,
    noSave: PropTypes.bool,
    noReset: PropTypes.bool,
    noUndo: PropTypes.bool,
    password: PropTypes.bool,
    disabled: PropTypes.bool,
    saveTitle: PropTypes.string,
    resetTitle: PropTypes.string,
    clearTitle: PropTypes.string,

}



// WEBPACK FOOTER //
// ./src/app/widget/tag-input/index.jsx